import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const chartWrapper: SxStyle = {
  position: 'relative',
};

export const chartLabel: SxStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const info: SxStyle = {
  position: 'absolute',
  top: 0,
  left: (p) => p.spacing(20.5),
  bottom: 0,
};

export const value: SxStyle = {
  fontSize: (p) => p.typography.h3.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const label: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
};
